import { createFileRoute, redirect } from "@tanstack/react-router"

/** Bookmarks to the old company profile route land in settings. */
export const Route = createFileRoute("/recruit/profile")({
  beforeLoad: () => {
    throw redirect({ to: "/recruit/settings/company" })
  },
  component: () => null,
})
